var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-left"},[_c('div',{staticClass:"logo-wrapper"},[_c('Logo')],1),_c('div',{staticClass:"nav-wrapper"},[_c('NavMenu')],1)]),_c('div',{staticClass:"header-right"},[_c('a-space',{attrs:{"size":4}},[_c('ProjectMenu'),_c('Feedback'),_c('Mention'),_c('AvatarMenu')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }